import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@nextui-org/react";
import React from "react";
import { StandardCancelButton, StandardDeleteButton } from "./StandardButtons";

const UnifiedDeleteModal = ({
  isOpen,
  onOpenChange,
  onConfirm,
  title = "Delete Item",
  message = "Are you sure you want to delete this item?",
  confirmText = "Delete",
  cancelText = "Cancel",
  itemName = "",
  itemType = "item",
  showItemName = true,
}) => {
  const handleConfirm = (onClose) => {
    onConfirm();
    onClose();
  };

  const getDisplayMessage = () => {
    if (itemName && showItemName) {
      return `${message} "${itemName}"?`;
    }
    return message;
  };

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange} size="md">
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">
              {title}
            </ModalHeader>
            <ModalBody>
              <p className="text-sm">
                {getDisplayMessage()}
              </p>
              <p className="text-xs text-gray-500 mt-2">
                This action cannot be undone.
              </p>
            </ModalBody>
            <ModalFooter>
              <StandardCancelButton onPress={onClose}>
                {cancelText}
              </StandardCancelButton>
              <StandardDeleteButton onPress={() => handleConfirm(onClose)}>
                {confirmText}
              </StandardDeleteButton>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default UnifiedDeleteModal; 